export const SportsData = [
  // {
  //   "SportsName": "Sports Complex",
  //   "Para1": "The IIT Gandhinagar Sports Complex is a world class state-of-the-art facility designed to cater to their sporting and fitness needs of the students, faculty, and staff of the Institute with the intention to promote  a healthy & active lifestyle. The complex is spread over an area of 15 acres and is open to all members of the institute and is also used for various sports events and tournaments throughout the year.",
  //   "Para2": "The Sports Complex at IIT Gandhinagar also offers coaching and training programs for various sports to help students and staff improve their skills and fitness levels. The facility is managed by a team of qualified and experienced coaches and trainers who provide personalized attention and guidance to each individual.",
  //   "Para3":"",
  //   "GameRules": [],
  //   "CardImage": require("../assets/sports/Sports Complex-1.jpg"),
  //   "Images": [
  //     require("../assets/sports/Sports Complex-1.jpg"),
  //     require("../assets/sports/Sports Complex-2.jpg"),
  //     require("../assets/sports/Sports Complex-3.jpg"),
  //   ],
  //   "Achievements": [],
  // },

  {
    "SportsName": "Aquatic",
    "Para1": "IIT Gandhinagar Aquatics Arena features a 50-meter Olympic size swimming pool with 10 lanes and a depth ranging from 1.2 to 2 meters. The pool is equipped with the latest technology and infrastructure to provide world-class training facilities to the students and athletes of IITGN, as well as to the wider community. In addition to the main pool, the Aquatics Arena also has a separate training pool with a depth of 1.2 meters  and a baby pool with a depth of 60 cms for toddlers.",
    "Para2": "The Aquatics Arena has a seating capacity of over 200 spectators, making it an ideal venue for hosting swimming competitions at the national and international level. The facility also includes locker rooms, showers, and changing areas for athletes and visitors.",
    "Para3": "",
    "GameRules": [],
    "CardImage": require("../assets/sports/Aquatics-1.jpg"),
    "Images": [
      require("../assets/sports/Aquatics-1.jpg"),
      require("../assets/sports/Aquatics-2.jpg"),
      require("../assets/sports/Aquatics-3.jpg"),
      require("../assets/sports/Aquatics-4.jpg"),
    ],
    "Achievements": [
      {
        "Awards": "Bronze Medal(Swimming-200m Backstroke - 48th Inter-IIT Aquatics meet)",
        "Sports-person": "Animesh Kumawat",
        "Year": 2012
      },
      {
        "Awards": "Silver Medal(Swimming-1500m Freestyle - 48th Inter-IIT Aquatics meet)",
        "Sports-person": "Animesh Kumawat",
        "Year": 2012
      },
      {
        "Awards": "Gold Medal(Swimming-50m Breaststroke- 50th Inter-IIT Aquatics meet)",
        "Sports-person": "Nnisha Rawat",
        "Year": 2016
      },
      {
        "Awards": "Silver Medal(Swimming-100m Backstroke - Inter-IIT Aqua meet 2011)",
        "Sports-person": "Parth Sane Vishwas",
        "Year": 2012
      },
      {
        "Awards": "Bronze Medal(Swimming-1500m Freestyle - 50th Inter-IIT Aquatics meet)",
        "Sports-person": "Animesh Kumawat",
        "Year": 2015
      },
      {
        "Awards": "Silver Medal(Swimming-50m Breaststroke- 50th Inter-IIT Aquatics meet)",
        "Sports-person": "Nnisha Rawat",
        "Year": 2015
      },
      {
        "Awards": "Gold Medal(Swimming-50m Butterfly - Inter-IIT Aqua meet 2011)",
        "Sports-person": "Parth Sane Vishwas",
        "Year": 2012
      },
      {
        "Awards": "Bronze Medal(Swimming-5om Backstroke - State level Swimming tournament organised by Guj State Aquatic Association)",
        "Sports-person": "Parth Sane Vishwas",
        "Year": 2012
      },
      {
        "Awards": "Bronze Medal(Swimming-50m Butterfly - State level Swimming tournament organised by Guj State Aquatic Association)",
        "Sports-person": "Parth Sane Vishwas",
        "Year": 2012
      },
      {
        "Awards": "Bronze Medal(Swimming-50m Freestyle - 48th Inter-IIT Aquatics meet)",
        "Sports-person": "Parth Sane Vishwas",
        "Year": 2012
      },
      {
        "Awards": "Silver Medal(Swimming-200m Backstroke - 50th Inter-IIT Aquatics meet)",
        "Sports-person": "Animesh Kumawat",
        "Year": 2015
      },
      {
        "Awards": "Bronze Medal(Swimming-200m Freestlye - 48th Inter-IIT Aquatics meet)",
        "Sports-person": "Animesh Kumawat",
        "Year": 2012
      },
      {
        "Awards": "Bronze Medal(Swimming-100m Backstroke - 50th Inter-IIT Aquatics meet)",
        "Sports-person": "Animesh Kumawat",
        "Year": 2015
      },
      {
        "Awards": "Silver Medal(Swimming-100m Freestyle - 48th Inter-IIT Aquatics meet)",
        "Sports-person": "Parth Sane Vishwas",
        "Year": 2012
      },
      {
        "Awards": "Bronze Medal(Swimming-50m Butterfly - 50th Inter-IIT Aquatics meet)",
        "Sports-person": "Parth Sane Vishwas",
        "Year": 2015
      },
      {
        "Awards": "Silver Medal(Swimming-100m Backstroke - 48th Inter-IIT Aquatics meet)",
        "Sports-person": "Parth Sane Vishwas",
        "Year": 2012
      },
      {
        "Awards": "Silver Medal(Swimming-400m Freestyle - 48th Inter-IIT Aquatics meet)",
        "Sports-person": "Animesh Kumawat",
        "Year": 2012
      },
      {
        "Awards": "Bronze Medal(Swimming-50m Backstroke - 50th Inter-IIT Aquatics meet)",
        "Sports-person": "Parth Sane Vishwas",
        "Year": 2015
      },
      {
        "Awards": "Gold Medal(Swimming-50m Butterfly - 48th Inter-IIT Aquatics meet)",
        "Sports-person": "Parth Sane Vishwas",
        "Year": 2012
      }
    ]
  },


  {
    "SportsName": "Athletics",
    "Para1": "The Athletics Track is built around the perimeter of the football ground, creating a multi-purpose venue that can be used for a wide range of sports and activities. The track's location around the football ground also makes it an ideal venue for multi-sport events and activities, including combined track and field events, and fitness training programs that incorporate both running and football skills.",
    "Para2": "The track features an eight-lane synthetic running surface, which is highly durable and provides excellent traction for runners. It is equipped with all the necessary markings for sprinting, middle-distance, and long-distance events, as well as field events such as long jump, triple jump, high jump, javelin throw, shot put, discus throw, and hammer throw. In addition to the track itself, the facility also includes flood lights that provide 165 lux of brightness on the track, a warm up track, seating areas for spectators, locker rooms and shower facilities for athletes.",
    "Para3": "",
    "GameRules": ["The ground will be available for use from 6 AM to 9 PM.", "Proper sports gear and attire ( for ex. Tracksuit, track pant, lower, t-shirts etc.)  is a must.", "Jogging on a wet track is strictly prohibited.", "Usage of floodlights after 9 PM will only be allowed in special cases.", "Food and beverages are prohibited on the track"],
    "CardImage": require("../assets/sports/Athletics-1.jpg"),
    "Images": [
      require("../assets/sports/Athletics-1.jpg"),
      require("../assets/sports/Athletics-2.jpg"),
      require("../assets/sports/Athletics-3.jpg"),
      require("../assets/sports/Athletics-4.jpg"),
     
    ],
    "Achievements": ""
  },
  {
    "SportsName": "Badminton",
    "Para1": "Located on the first floor of the sports complex are six courts split across two arenas, each with a BWF approved PU flooring that provides excellent shock absorption and traction for players. The courts are surrounded by a high ceiling and walls to prevent interference from outside factors such as wind and sun glare, ensuring that players can focus solely on their game. In addition to the courts themselves, the facility also includes seating areas for spectators, locker rooms and shower facilities for players",
    "Para2": "The Badminton halls are open to both IIT students and members of the wider community, and is used for a variety of events throughout the year, including inter-collegiate and national-level competitions, as well as training sessions for local players and school children. The hall is equipped with state-of-the-art lighting and sound systems, ensuring that players and spectators alike can enjoy a high-quality experience.",
    "Para3": "",
    "GameRules": ["Timings will be 6 AM to 10 AM & 5 PM to 10 PM on weekdays and 6 AM to 10 PM on weekends.", "Only clean non marking shoes are allowed on the courts", "Proper sports attire (i.e. Tracksuit, shorts & t-shirts) is a must", "Spectators will be allowed only in the viewing gallery.", "Any heavy objects (like table,chair, etc.) should not be brought inside the hall", "Food and beverages will not be allowed inside the hall."],
    "CardImage": require("../assets/sports/Badminton-1.jpg"),
    "Images": [
      require("../assets/sports/Badminton-1.jpg"),
      require("../assets/sports/Badminton-2.jpg"),
      require("../assets/sports/Badminton-3.jpg"),
    ],
    "Achievements": [
      {
        "Awards": "Open badminton championship (Girl's Doubles)",
        "Sports-person": "Aparna Arya, Pratyusha Challa",
        "Year": 2013
      },
      {
        "Awards": "Winner single and doubles(Concours DAIICT)",
        "Sports-person": "Vaishnavi Patil, Swasti Medha",
        "Year": 2014
      },
      {
        "Awards": "1st position: Badminton championship(Concours DAIICT)",
        "Sports-person": "Shruti Jain and Swati Verma",
        "Year": 2011
      },
      {
        "Awards": "Badminton open Doubles Girls(Annual Sport Award)",
        "Sports-person": "KAparna Arya, Pratyusha Challa",
        "Year": 2014
      },
      {
        "Awards": "Open badminton championship (Boy's Doubles)",
        "Sports-person": "Kanak Sharma, Pranshul Saini",
        "Year": 2013
      },
      {
        "Awards": "Badminton open singles Girls(Annual Sport Award)",
        "Sports-person": "Aishwarya Agarwal",
        "Year": null
      },
      {
        "Awards": "Open badminton championship (Boy's singles)",
        "Sports-person": "Ishan Upadhyay",
        "Year": 2013
      },
      {
        "Awards": "Badminton open Doubles(Annual Sport Award)",
        "Sports-person": "Kanak Sharma, Pranshul Ssaini",
        "Year": 2014
      },
      {
        "Awards": "Best Girls team of the year",
        "Sports-person": "Girls team",
        "Year": 2012
      },
      {
        "Awards": "Badminton open singles(Annual Sport Award)",
        "Sports-person": "Ishan Upadhyay",
        "Year": 2014
      },
      {
        "Awards": "Silver Medal(Concours DAIICT)",
        "Sports-person": "Kshitija Anam , Devika Menon",
        "Year": 2019
      },
      {
        "Awards": "Open badminton championship (Girl's singles)",
        "Sports-person": "Aishwarya Agarwal",
        "Year": 2013
      },
      {
        "Awards": "Badminton Open Champion",
        "Sports-person": "Harsh Paliwal",
        "Year": 2012
      }
    ]
  },
  {
    "SportsName": "Basketball",
    "Para1": "At IITGN, there are a total of four basketball courts - one indoor and three outdoor. The indoor basketball court is equipped with all the necessary amenities for players to practice and play the game in a comfortable and safe environment. The court has a PU flooring and is well-lit with ample seating for 200 spectators.",
    "Para2": "The three outdoor basketball courts are also well-equipped with standard hoops and markings, making them suitable for both practice and matches. These courts are located in different parts of the campus, providing students and faculty members with easy access to sports facilities.",
    "Para3": "Basketball is a popular sport at IITGN, and the institute encourages students to participate in various sports and games as part of their holistic development.",
    "GameRules": ["Timings will be 6 AM to 10 AM & 5 PM to 10 PM on weekdays and 6 AM to 10 PM on weekends.", "Only clean non – marking shoes ( preferably high ankles) are allowed.", "Proper sports attire (i.e. Tracksuit, shorts & t-shirts) is a must", "Spectators will be allowed only in the viewing gallery.", "Any heavy objects (like table,chair, etc.) should not be brought inside the hall", "Food and beverages will not be allowed inside the hall."],
    "CardImage": require("../assets/sports/Basketball-1.jpg"),
    "Images": [
      require("../assets/sports/Basketball-1.jpg"),
      require("../assets/sports/Basketball-2.jpg"),
    ],
    "Achievements": [
      {
        "Awards": "Gold Medal(District level Khel Mahakumbh)",
        "Sports-person": "Boys team",
        "Year": "2015-16"
      },
      {
        "Awards": "Bronze Medal(Justice league)",
        "Sports-person": "Boys team",
        "Year": "2018-19"
      },
      {
        "Awards": "Winner(Concours DAIICT)",
        "Sports-person": "Boys Team",
        "Year": "2013"
      },
      {
        "Awards": "Genreal Championship winner(Petro Cup)",
        "Sports-person": "Girls Team",
        "Year": "2011"
      },
      {
        "Awards": "Winner Basketball Championship title(concours DAIICT)",
        "Sports-person": "Girls Team",
        "Year": "2012"
      },
      {
        "Awards": "Gold Medal(Khel Mhakumbh)",
        "Sports-person": "Boys team",
        "Year": "2011"
      },
      {
        "Awards": "Player of the Tournament(Capital Season League)",
        "Sports-person": "Ravi Kumar",
        "Year": "2013"
      },
      {
        "Awards": "Gold Medal(Khel Mhakumbh)",
        "Sports-person": "Girls team",
        "Year": "2011"
      },
      {
        "Awards": "Gold Medal(Khel Mhakumbh)",
        "Sports-person": "Boys team",
        "Year": "2014-15"
      },
      {
        "Awards": "Winner(Capital Season League)",
        "Sports-person": "Boys Team",
        "Year": "2013"
      },
      {
        "Awards": "Winner(VIBES'14: Nirma University)",
        "Sports-person": "Boys Team",
        "Year": "2014"
      },
      {
        "Awards": "silver Medal(concours DAIICT)",
        "Sports-person": "Boys team",
        "Year": "2016-17"
      },
      {
        "Awards": "Genreal Championship winner(Petro Cup)",
        "Sports-person": "Boys Team",
        "Year": "2011"
      },
      {
        "Awards": "Bronze Medal(Indian College Basketball League organised by Basketball Federarion of India)",
        "Sports-person": "Boys Team",
        "Year": "2014"
      },
      {
        "Awards": "Silver Medal(Genesis Cup)",
        "Sports-person": "Boys Team",
        "Year": "2012"
      },
      {
        "Awards": "Runner's up(Ahmedabad District Men's basketball Championship)",
        "Sports-person": "Boys Team",
        "Year": "2012"
      },
      {
        "Awards": "Bronze Medal(Khel Mhakumbh)",
        "Sports-person": "Girls team",
        "Year": "2014-15"
      },
      {
        "Awards": "Winner(Ahmedabad District Men's basketball Championship)",
        "Sports-person": "Boys Team",
        "Year": "2013"
      }
    ]
  },
  {
    "SportsName": "Chess",
    "Para1": "Chess is a timeless sport that requires strategic thinking, concentration, and patience. At IIT Gandhinagar, we recognize the benefits of playing chess, and we provide a platform for students to participate in this intellectually stimulating game. Our chess club (The Knight players) welcomes students of all levels, from beginners to advanced players. We provide a friendly and supportive environment for students to practice and improve their skills. Our club also hosts tournaments and competitions, giving students the opportunity to test their abilities and compete against other players from around the campus.",
    "Para2": "",
    "Para3": "",
    "GameRules": [],
    "CardImage": require("../assets/sports/Chess.jpg"),
    "Images":[
      require("../assets/sports/Chess.jpg"),
    ],
    "Achievements": [
      {
        "Awards": "Gold Medal(Justice League organized by GNLU)",
        "Sports-person": "",
        "Year": "2019-20"
      },
      {
        "Awards": "Gold Medal(Concours organized by DA-IICT)",
        "Sports-person": "",
        "Year": "2019-20"
      }
    ]
  },
  {
    "SportsName": "Cricket",
    "Para1": "IITGN Cricket Ground has a measurement of 65mts and has 4 wickets. The ground features a natural red soil turf pitch and a sand based grass outfield, which is well-maintained and provides a high-quality playing surface for cricket matches. The stadium is equipped with modern amenities and facilities, including changing rooms for players, umpires and officials, sight screens and public address system.",
    "Para2": "In addition to its natural turf pitch and outfield, the IITGN Cricket Ground is also equipped with floodlights that enable night games to be played. The installation of floodlights at the ground has significantly increased its versatility and has made it possible for matches to be played in the evenings or at night, even during the winter months when daylight hours are limited. With a light measurement of 700 lux on the pitch the ground is perfect for night matches.",
    "Para3": "The IITGN Cricket Ground is a popular venue for cricket matches and tournaments, and has hosted a number of important matches in the past.",
    "GameRules": ["Ground will be available for use from 6 AM to 9 PM", "Metal spike shoes won’t be allowed", "Proper sports attire ( for ex. Tracksuit, shorts, tshirts etc.)  is must", "Loitering will not be allowed within the 30 yards of the main cricket pitches.", "Usage of floodlights after 9 PM will only be allowed in special cases (D/N Matches)."],
    "CardImage": require("../assets/sports/Cricket-1.jpg"),
    "Images": [
      require("../assets/sports/Cricket-1.jpg"),
      require("../assets/sports/Cricket-2.jpg"),
    ],
    "Achievements": [
      {
        "Awards": "Gold Medal(ISRO cup)",
        "Sports-person": "Boys team",
        "Year": 2020
      },
      {
        "Awards": "Silver Medal(Concourt DAIICT)",
        "Sports-person": "Boys team",
        "Year": 2018
      }
    ]
  },
  {
    "SportsName": "Football",
    "Para1": "Football is associated with passion, emotion, and excitement but most importantly team spirit and continuous dedication. The football field is one of the most beautiful places on campus to visit under the floodlights at dusk. It is a place visited by choice but ends up staying with you forever.  Football at IITGN is made possible by the collective efforts from the staff members, groundsmen, the team of players, and our beloved coach. Each year the team strives to work hard and improve on results not only at the inter IITs but also at various local tournaments. IIT Gandhinagar has seen many great footballers over the past few years and it’s the never die attitude that has united us for years. IIT Gandhinagar has a full sized football field with floodlights providing brightness of approx. 283 lux on the field.",
    "Para2": "",
    "Para3": "",
    "GameRules": ["Field will be available for use from 6 AM to 9 PM", "Proper shoes (for ex. studs) and sports attire ( for ex. Tracksuit, trackpant, lower, tshirts etc.)  applies in the normal sessions", "All the football players must avoid unnecessary passage through the athletic track in order to avoid disturbance.", "Usage of floodlights after 9 PM will only be allowed in special cases.", "Food and beverages are prohibited on the ground."],
    "CardImage": require("../assets/sports/Football-1.jpg"),
    "Images": [
      require("../assets/sports/Football-1.jpg"),
      require("../assets/sports/Football-2.jpg"),
      require("../assets/sports/Football-3.jpg"),
      require("../assets/sports/Football-4.jpg"),
   
    ],
    "Achievements": [
      {
        "Awards": "Silver Medal(Gandhinagar District Football Association League)",
        "Sports-person": "Boys team",
        "Year": 2015
      }
    ]
  },
  // {
  //   "SportsName": "Frisbee",
  //   "Para1": "Ultimate Frisbee is a budding sport that has attracted great enthusiasm among the entire IIT Gandhinagar community. With the rising popularity over the years, we have seen many students climb up the ranks and bring laurels for the institute at national level sports tournaments. The main event which everyone eagerly awaits is the time of Hallabol, the intra-college sports fest. This is where the new players get to showcase their skills with the disc and come into the spotlight. The Ultimate community at IIT Gandhinagar comprises players from diverse sports backgrounds but sharing a common passion and love for the game of Ultimate. Our community shares a very close bond with each other and the team always welcomes any person interested in honing their disc-handling skills.",
  //   "Para2": "",
  // "Para3": "",
  //   "GameRules": [],
  //   "CardImage": require("../assets/sports/Frisbee.jpg"),
  //   "Achievements": [
  //     {
  //       "Awards": "Silver Medal(Shaurya IIMA)",
  //       "Sports-person": "Mixed Team",
  //       "Year": 2017
  //     }
  //   ]
  // },
  {
    "SportsName": "Gym & Weightlifting",
    "Para1": "At IIT Gandhinagar, we believe that fitness is an essential part of a healthy lifestyle, and our air-conditioned gym is designed to help our students, faculty, and staff achieve their fitness goals in a comfortable and safe indoor environment. Our gym is spacious enough to host up to 40 people at a time, ensuring that everyone has ample space to work out and move around freely.",
    "Para2": "We understand the importance of having the right equipment to facilitate a good workout, which is why our gym is well equipped with state-of-the-art machines that cater to a variety of fitness needs. Gym has a full-sized wall mirror and also Polyurethane flooring to prevent slipping",
    "Para3": "",
    "GameRules": ["Gym will operate for all the community members from 6 to 9 AM, 10 AM to 1 PM, 2 PM to 5 PM and 6 to 9 PM.", "Clean non – marking shoes are recommended.", "Proper sports attire (i.e. Tracksuit, shorts & t-shirts) is a must", "One individual will be allowed to use the gym facilities for a maximum of 1 hour in a day in order to vacate the facilities for others.", "No one will be allowed to access the gym in absence of the trainer and outside the designated time slots.", "Food and beverages will not be allowed inside the hall."],
    "CardImage": require("../assets/sports/Gym-1.jpg"),
    "Images": [
      require("../assets/sports/Gym-1.jpg"),
      require("../assets/sports/Gym-2.jpg"),
      require("../assets/sports/Gym-3.jpg"),
      require("../assets/sports/Gym-4.jpg"),
      require("../assets/sports/Gym-5.jpg"),
    ],
    "Achievements": ""
  },
  // {
  //   "SportsName": "Lawn Tennis",
  //   "Para1": "Tennis is always known for its profound history and its royalty. The game that originated in 1873 has made a permanent place in the hearts of every generation. Tennis shapes your personality physically, mentally and emotionally.  When on the court the IIT Gandhinagar team feels like a family. The team strives hard for getting better at the game each day. Each drop of sweat dripped on the court builds our character. We definitely aim at winning but most importantly we are inclined towards witnessing moments worth remembering till eternity.",
  //   "Para2": "",
  // "Para3": "",
  //   "GameRules": [],
  //   "CardImage": require("../assets/sports/Lawn Tennis.jpg"),
  //   "Achievements": ""
  // },
  {
    "SportsName": "Squash",
    "Para1": "Squash is designed to cater to players of all levels, from beginners to professionals. With three international standard courts, we provide a platform for squash enthusiasts to showcase their skills and elevate their game. Our courts are constructed with the latest technology and equipment, ensuring that our players have a seamless and thrilling experience every time they step onto the court.",
    "Para2": "",
    "Para3": "",
    "GameRules": ["The court will be available for use from 6 AM to 9 PM.", "Proper sports gear and attire ( for ex. Tracksuit, track pant, lower, t-shirts etc.)  is a must."],
    "CardImage": require("../assets/sports/Squash-1.jpg"),
    "Images": [
      require("../assets/sports/Squash-1.jpg"),
      require("../assets/sports/Squash-2.jpg"),
      require("../assets/sports/Squash-3.jpg"),
    ],
    "Achievements": ""
  },
  {
    "SportsName": "Table Tennis",
    "Para1": "Besides being a fun activity to spend healthy time with your family and friends, there are many health and other benefits of playing table tennis. Table Tennis is a retro and fast-paced competitive sport and is the world’s best brain sport.  It’s a sport that students can enjoy playing at any time as indoor sports with all the required equipment available on the campus. Besides professional table tennis players, other students also enjoy practicing it and remain active which definitely helps to improve the sports culture of IITGN. IITGN has got outstanding Table tennis players over the past years whose performances in Inter IIT and many other tournaments keep motivating succeeding teams. This game has taught us the importance of perseverance, control and besides this, the value of having a strong team with dedicated and motivating teammates.",
    "Para2": "IITGN Community is fortunate to have Table Tennis facility on campus and it has helped form a friendly bond between the community members, be it faculties or staff members or students. We have a TT hall with Polyurethane flooring and 5 tables. The hall is well lit and has a spectators area with a capacity of 40 people. Additionally, if required, the hall can still accommodate ore tables.",
    "Para3": "",
    "GameRules": [],
    "CardImage": require("../assets/sports/Table Tennis-1.jpg"),
    "Images": [
      require("../assets/sports/Table Tennis-1.jpg"),
      require("../assets/sports/Table Tennis-2.jpg"),
     
    ],
    "Achievements": [
      {
        "Awards": "Winner (Intra-college Sports Tournament)",
        "Sports-person": "Tapan Shah",
        "Year": "2013-14"
      },
      {
        "Awards": "Gold Medal(Shaurya Cup IIMA)",
        "Sports-person": "TT Team (Nikhil Sharma, Sowill Dave, Amber Kothari, Bharg Mehta)",
        "Year": "2016-17"
      },
      {
        "Awards": "Winner(concours DAIICT)",
        "Sports-person": "TT Boys Team",
        "Year": "2016"
      },
      {
        "Awards": "Bronze Medal(Khel Mhakumbh)",
        "Sports-person": "Chetas Joshi",
        "Year": "2013"
      },
      {
        "Awards": "Winner (concours DAIICT)",
        "Sports-person": "TT Men's Team",
        "Year": "2015-16"
      },
      {
        "Awards": "Silver Medal(District level Khel Mmahakumbh)",
        "Sports-person": "Nikhil Sharma",
        "Year": "2015-16"
      },
      {
        "Awards": "Winner(Shaurya' 16 Aannual Sports Fest of IIMA)",
        "Sports-person": "TT Boys Team",
        "Year": "2016"
      },
      {
        "Awards": "Silver Medal(Shaurya Cup IIMA)",
        "Sports-person": "TT Team",
        "Year": "2015-16"
      },
      {
        "Awards": "Winner(Justice League GNLU)",
        "Sports-person": "TT Team",
        "Year": "2015-16"
      },
      {
        "Awards": "Annual Sports Award(TT Open)",
        "Sports-person": "Nikhil Sharma",
        "Year": "2014-15"
      }
    ]
  },
  {
    "SportsName": "Volleyball",
    "Para1": "Volleyball is one of the most popular sports in the IITGn campus and students from various departments can be seen spiking balls on the court till late nights. It is a sport familiar with many faculty members as well as many of them participate in the yearly Srija Memorial League. The Volleyball team of IITGn is gathering its mettle to emerge as one of the best teams out there! Volleyball is a sport that makes you feel alive and determined. Serve it tight, set it high, dig it fiercely and spike it hard!",
    "Para2": "Volleyball is a team sport which in addition to physical fitness, also improves hand-eye coordination, reflexes, and balance. We have 1 indoor volleyball court with polyurethane flooring and a viewing gallery of 40 spectators. Halls are prepared with echo-proof walls to cut down the sound of hitting volleyball.",
    "Para3": "",
    "GameRules": ["Timings will be 6 AM to 10 AM and 5 PM to 10 PM on weekdays & 6 AM to 10 PM on weekends.", "Only clean non – marking shoes are allowed.", "Proper sports attire (i.e. Tracksuit, shorts & t-shirts) is a must", "Spectators will be allowed only in the viewing gallery.", "Any heavy objects (like table,chair, etc.) should not be brought inside the hall", "Food and beverages will not be allowed inside the hall"],
    "CardImage": require("../assets/sports/Volleyball-1.jpg"),
    "Images":[
      require("../assets/sports/Volleyball-1.jpg"),
    ],
    "Achievements": [
      {
        "Awards": "Winner (concours DAIICT)",
        "Sports-person": "Girls Team",
        "Year": 2015
      },
      {
        "Awards": "Player of the tournament (Capital Season League 2013)",
        "Sports-person": "Endla Naveen",
        "Year": 2013
      },
      {
        "Awards": "Winner (concours DAIICT)",
        "Sports-person": "Girls Team",
        "Year": 2016
      },
      {
        "Awards": "Silver Medal(Shaurya- IIMA)",
        "Sports-person": "Girls Team",
        "Year": 2016
      },
      {
        "Awards": "Silver Medal(Capital Season League 2013)",
        "Sports-person": "Boys team",
        "Year": 2013
      },
      {
        "Awards": "Gold Medal(Shaurya- IIMA)",
        "Sports-person": "Girls Team",
        "Year": 2014
      }
    ]
  },
  {
    "SportsName": "Wall Climbing",
    "Para1": "Wall climbing is a thrilling and challenging sport that has gained immense popularity in recent years. It is a great exercise that helps develop overall physical fitness. Our climbing wall is designed to provide a safe and enjoyable experience for climbers of all levels, from beginners to advanced athletes. The wall features a variety of routes with different levels of difficulty, allowing climbers to challenge themselves and progress at their own pace.",
    "Para2": "At our climbing wall, we provide all the necessary equipment and safety gear, including ropes, harnesses, and helmets. Our experienced instructors are also available to offer guidance and support to climbers, ensuring a safe and enjoyable experience for everyone.",
    "Para3": "",
    "GameRules": ["Always wear the necessary safety equipment, including a harness, helmet, and climbing shoes.",
    "Keep your body close to the wall and avoid swinging or jumping while climbing.",
    "Always use proper technique and do not rely solely on your upper body strength to climb.",
    "If you fall, keep your arms and legs close to your body to avoid injuries.",
    "If you are a beginner, make sure to receive proper training and instruction before starting to climb on your own."],
    "CardImage": require("../assets/sports/Wall Climbing-1.jpg"),
    "Images": [
      require("../assets/sports/Wall Climbing-1.jpg"),
      require("../assets/sports/Wall Climbing-2.jpg"),
      require("../assets/sports/Wall Climbing-3.jpg"),
    ],
    "Achievements": ""

  },
  {
    "SportsName": "Yoga",
    "Para1": "At our sports complex, we have a well-equipped yoga hall that is perfect for hosting yoga sessions. The hall is designed to create a serene and calming environment, with natural light and proper ventilation. It has a capacity of 25 people, making it perfect for group yoga classes. The hall features Polyurethane flooring, which provides a comfortable and slip-resistant surface to practice yoga on. The mirrored wall in the hall allows students to check their form and alignment during the practice.",
    "Para2": "In addition to yoga, the hall can also be utilized for other activities like aerobics, zumba, and other fitness classes. The lockers in the hall provide a safe and secure space for students to store their personal belongings while they practice. Our yoga classes are led by experienced and certified instructors who provide guidance and support to students of all levels, from beginners to advanced practitioners.",
    "Para3": "",
    "GameRules": ["Timings will be 6 AM to 8 AM and 6 PM to 8 PM.", "Proper attire is a must.", "Yoga hall will be a multipurpose hall which will also be used for Aerobics and Zumba.", "Non-marking shoes will be allowed while performing Aerobic and Zumba activities, while yoga will be performed barefoot.", "Any heavy objects (like table,chair, etc.) should not be brought inside the hall", "Food and beverages will not be allowed inside the hall."],
    "CardImage": require("../assets/sports/Yoga-1.jpg"),
    "Images":[
      require("../assets/sports/Yoga-1.jpg"),
    ],
    "Achievements": ""
  }

]